import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function LoadingWrapper({ isLoading, minHeight = '400px', size = 60, children }) {
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight 
      }}>
        <CircularProgress size={size} />
      </div>
    );
  }

  return <>{children}</>;
}
